import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const Copyright = () => {
  return (
    <section id="copyright" style={{ backgroundColor: "#efefef" }}>
      <Container maxWidth="lg" sx={{ padding: "22px 0" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                variant="body2"
                component="p"
                gutterBottom
                align="center"
              >
                Copyright © 2023 simbanic. All Rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default Copyright;
